<template>
	<div>
		<a-modal title="选择审批单" :visible="is_revocation" width="70%" @cancel="closeDetali">
			<template slot="footer">
				<a-button key="back" @click="closeDetali"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="selectCode"> 确定 </a-button>
			</template>
			<a-tabs :default-active-key="activeKey" @change="callback">
				<a-tab-pane key="1" tab="我的待办">
					<div>
							<a-select  show-search :filter-option="filterOption" allowClear style="width: 200px;margin-top: 10px;" v-model="type" placeholder="关联审批单类型" v-if="kind != 1" :disabled="type && selectIndex == 0">
						<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
							{{ item.name }}
						</a-select-option>
					</a-select>
					<a-input v-model="goodsName" allowClear class="a_input_self margin_self" placeholder="物品名称" style="margin: 10px;" v-if="kind == 1" @keyup.enter.native="get_ing"/>
					<a-button type="primary" @click="get_ing" style="margin-left: 10px;" > 查询 </a-button>
					</div>
				
					<a-table style="margin-top: 10px;" :data-source="lis1" bordered :pagination="pagination1" rowKey="id" @change="handleTableChange" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination1.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="createTime" title="申请时间" data-index="createTime" />
						<a-table-column key="processName" title="申请标题" data-index="processName" />
						<a-table-column title="审批结果" width="80px">
							<template scope="text,record">
									<a-tag :color="result_apply[record.result].color">
										{{result_apply[record.result].txt}}
						            </a-tag>
							</template>
						</a-table-column>
						<a-table-column title="操作" width="180px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDaildb(record)">详情</a>
								<a-divider type="vertical" v-if="kind == 1"/>
								<a @click="showGoods(record)" v-if="kind == 1">选择物品</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
				<a-tab-pane key="2" tab="我的已办" force-render>
					<a-input v-model="applyer2" allowClear class="a_input_self margin_self" placeholder="申请人" style="margin: 10px;" @keyup.enter.native="get_done"/>
					<a-input v-model="goodsName2" allowClear class="a_input_self margin_self" placeholder="物品名称" style="margin: 10px;" v-if="kind == 1" @keyup.enter.native="get_done"/>
					<a-select show-search :filter-option="filterOption" allowClear style="width: 200px;" v-model="type2" placeholder="关联审批单类型" v-if="kind != 1" :disabled="type2 && selectIndex == 0">
						<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
							{{ item.name }}
						</a-select-option>
					</a-select>
					<a-button type="primary" @click="get_done" style="margin-left: 10px;"> 查询 </a-button>
					<a-table :data-source="lis2" bordered :pagination="pagination2" rowKey="id" @change="handleTableChange2" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange2 }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination2.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="startTime" title="申请时间" data-index="startTime" />
						<a-table-column key="title" title="申请标题" data-index="title" />
						<a-table-column title="审批结果" width="80px">
							<template scope="text,record">
									<a-tag :color="result_apply[record.result].color">
										{{result_apply[record.result].txt}}
						            </a-tag>
							</template>
						</a-table-column>
						<a-table-column title="操作" width="180px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDail2(record)">详情</a>
								<a-divider type="vertical" v-if="kind == 1"/>
								<a @click="showGoods1(record)" v-if="kind == 1">选择物品</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
				<a-tab-pane key="3" tab="我的申请">
					<a-input v-model="applyer3" allowClear class="a_input_self margin_self" style="margin: 10px;" placeholder="申请人" @keyup.enter.native="get_mylis"/>
					<a-input v-model="goodsName3" allowClear class="a_input_self margin_self" placeholder="物品名称" style="margin: 10px;" v-if="kind == 1" @keyup.enter.native="get_mylis"/>
					<a-select  show-search :filter-option="filterOption" allowClear style="width: 200px;" v-model="type3" placeholder="关联审批单类型" v-if="kind != 1" :disabled="type3 && selectIndex == 0">
						<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
							{{ item.name }}
						</a-select-option>
					</a-select>
					<a-button type="primary" @click="get_mylis" style="margin-left: 10px;"> 查询 </a-button>
					<a-table :data-source="lis3" bordered :pagination="pagination3" rowKey="id" @change="handleTableChange3" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange3 }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination3.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="applyTime" title="申请时间" data-index="applyTime" />
						<a-table-column key="title" title="申请标题" data-index="title" />
						<a-table-column title="审批结果" width="80px">
							<template scope="text,record">
									<a-tag :color="result_apply[record.result].color">
										{{result_apply[record.result].txt}}
						            </a-tag>
							</template>
						</a-table-column>
						<a-table-column title="操作" width="180px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDail(record)">详情</a>
								<a-divider type="vertical" v-if="kind == 1"/>
								<a @click="showGoods3(record)" v-if="kind == 1">选择物品</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
				<a-tab-pane key="4" tab="抄送我的">
					<a-input v-model="applyer4" allowClear class="a_input_self margin_self" style="margin: 10px;" placeholder="申请编号" @keyup.enter.native="get_Taskdone"/>
					<a-select  show-search :filter-option="filterOption" allowClear style="width: 200px;" v-model="type4" placeholder="关联审批单类型"  v-if="kind != 1" :disabled="type4 && selectIndex == 0">
						<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
							{{ item.name }}
						</a-select-option>
					</a-select>
					<a-input v-model="applyer4" allowClear class="a_input_self margin_self" style="margin: 10px;" placeholder="请输入申请人" @keyup.enter.native="get_Taskdone"/>
					
					<a-button type="primary" @click="get_Taskdone"  style="margin-left: 10px;"> 查询 </a-button>
					<a-table :data-source="lis4" bordered :pagination="pagination4" rowKey="id" @change="handleTableChange4" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange4 }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination4.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="applyTime" title="申请时间" data-index="applyTime" />
						<a-table-column key="title" title="申请标题" data-index="title" />
						<a-table-column title="审批结果" width="80px">
							<template scope="text,record">
									<a-tag :color="result_apply[record.result].color">
										{{result_apply[record.result].txt}}
						            </a-tag>
							</template>
						</a-table-column>
						<a-table-column title="操作" width="180px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDail2(record)">详情</a>
								<a-divider type="vertical" v-if="kind == 1"/>
								<a @click="showGoods2(record)" v-if="kind == 1">选择物品</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
				<a-tab-pane key="5" tab="全部" v-if="newApply == 1">
					<a-input v-model="queryParam.applyCode" allowClear class="a_input_self margin_self" style="margin: 10px;" placeholder="申请单子号" @keyup.enter.native="get_AllData"/>
					<a-select  show-search :filter-option="filterOption" allowClear style="width: 200px;" v-model="type5" placeholder="关联审批单类型"  v-if="kind != 1" :disabled="selectIndex == 0">
						<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
							{{ item.name }}
						</a-select-option>
					</a-select>
					<a-input v-model="queryParam.applyer5" allowClear class="a_input_self margin_self" style="margin: 10px;" placeholder="请输入申请人" @keyup.enter.native="get_AllData"/>
					<!-- 缺公司部门 -->
					 <a-select show-search allowClear placeholder="公司名称" class="margin_self" @change="handlecompany" v-model="queryParam.companyId"
						@keyup.enter.native="get_AllData" style="width: 200px" >
							<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
							{{ item.title }}
							</a-select-option>
					</a-select>
					<a-tree-select allowClear :tree-data="deptList" placeholder="部门名称" :disabled="!this.queryParam.companyId" style="width: 200px; margin-right: 5px" 
					v-model="queryParam.deptId" @keyup.enter.native="get_AllData" >
					</a-tree-select>
					<a-button type="primary" @click="get_AllData"  style="margin-left: 10px;"> 查询 </a-button>
					<a-table :data-source="lis5" bordered :pagination="pagination5" rowKey="id" @change="handleTableChange5" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange5 }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination5.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="title" title="申请标题" data-index="title" />
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="companyName" title="申请公司" data-index="companyName" />
						<a-table-column key="deptName" title="申请部门" data-index="deptName" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="applyTime" title="申请时间" data-index="applyTime" />
						<a-table-column title="审批结果" width="80px">
							<template scope="text,record">
									<a-tag :color="result_apply[record.result].color">
										{{result_apply[record.result].txt}}
						            </a-tag>
							</template>
						</a-table-column>
						<a-table-column title="操作" width="180px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDail5(record)">详情</a>
								<a-divider type="vertical" v-if="kind == 1"/>
								<a @click="showGoods5(record)" v-if="kind == 1">选择物品</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
			</a-tabs>
			
		</a-modal>
		<newPaymentModel  ref="newPaymentModel"></newPaymentModel>
		<leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
		<purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" :typeIndex="typeIndex" :number="number" @getData="getData" :apply="apply" @changeNumber="changeNumber"/>
		<proc-flow-modal ref="modal" @ok="handleOk" :audit="false" />
		<!-- 报废 -->
		<scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
		<!-- 审批领用 -->
		<receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
		<operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
		<service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
		<reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
		<!-- 详情 -->
		<payMentModal ref="paymentmodal" @ok="handleOk" :audit="false" />
		<!-- 详情 -->
		<contractModal ref="contractmodal" @ok="handleOk" :audit="false" />
		<sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
		<currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
		<returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
		<car-modal ref="carmodal" @ok="handleOk" :audit="false" />
		<returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
		<salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
		<adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
		<charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
		<other-modal ref="othermodal" @ok="handleOk" :audit="false" />
		<feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
	</div>
</template>
<script>
    import { limitCompany } from '@/utils/limitCompany'
	import {
		getTasking,
		getTaskingData,
		getTaskdone,
		getTaskdoneData,
		getBusinessListMy,
		getBusinessListMyData,
		getTaskdone_cc,
		getTaskdone_ccData,
		modalMap
	} from '@/api/activiti'
	import {audit_list,getall } from '@/api/financial'
	import LeaveModal from '@/views/activiti/modules/LeaveModal.vue'
	import PurchaseModal from '@/views/activiti/modules/PurchaseModal.vue'
	import ProcFlowModal from '@/views/activiti/modules/ProcFlowModal.vue'
	import receiveModal from '@/views/activiti/modules/receiveModal.vue' //领用
	import ScrapModal from '@/views/activiti/modules/ScrapModal.vue' //报废
	import OperationModal from '@/views/activiti/modules/OperationModal.vue'
	import ServiceModal from '@/views/activiti/modules/ServiceModal.vue'
	import ReimbursementModal from '@/views/activiti/modules/ReimbursementModal.vue'
	import payMentModal from '@/views/activiti/modules/payMentModal.vue'
	import contractModal from '@/views/activiti/modules/contractModal.vue'
	import sealModal from '@/views/activiti/modules/sealModal.vue'
	import currencyModal from '@/views/activiti/modules/currencyModal.vue'
	import returnModal from '@/views/activiti/modules/returnModal.vue'
	import carModal from '@/views/activiti/modules/carModal.vue'
	import returncarModal from '@/views/activiti/modules/returncarModal.vue'
	import salaryModal from '@/views/activiti/modules/salaryModal.vue'
	import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
	import chargeModal from '@/views/activiti/modules/chargeModal.vue'
	import otherModal from '@/views/activiti/modules/otherModal.vue'
	import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
	import newPaymentModel from '@/views/activiti/modules/newPaymentModel.vue'
	export default {
		components: {
			LeaveModal,
			ProcFlowModal,
			PurchaseModal,
			receiveModal,
			ScrapModal,
			OperationModal,
			ServiceModal,
			ReimbursementModal,
			payMentModal,
			contractModal,
			sealModal,
			currencyModal,
			returnModal,
			carModal,
			returncarModal,
			salaryModal,
			adjustmentModal,
			chargeModal,
			otherModal,
			feedbackModal,
			newPaymentModel
		},
		data() {
			return {
				
				queryParam: {
					companyId: undefined,
				    applyer5: '',
					deptId: undefined,
					applyCode: ''

				},
				companylist: [],
				deptList: [],
				

				// colorList: {
				//  '审批中':  '#FAAD14',
				//  '通过': '#52C41A',
				//  '驳回': '#FF4D4F',
				//  '撤销': '#999999',
			    //  '中止': '#222222',
				// },
				goodsName: '',
				number: 0,
				apply: 0,
				selectedRowKeys: [],
				Approvallist:[],
				rowInfo: [],
				rowInfo2: [],
				rowInfo3: [],
				rowInfo4: [],
				rowInfo5: [],
				activeKey: '1',
				is_revocation: false,
				type: undefined,
				type2: undefined,
				type3: undefined,
				type4: undefined,
				type5: undefined,
				applyer2:'',
				applyer3:'',
				applyer4:'',
				pagination1: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showSizeChanger: true,
					itemName: '',
					hideOnSinglePage:false
				},
				lis1: [],
				pagination2: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
			
					showSizeChanger: true,
					itemName: '',
					hideOnSinglePage:false
				},
				lis2: [],
				pagination3: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showSizeChanger: true,
					itemName: '',
					hideOnSinglePage:false
				},
				lis3: [],
				pagination4: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showSizeChanger: true,
					itemName: '',
					hideOnSinglePage:false
				},
				lis4: [],
				pagination5: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showSizeChanger: true,
					itemName: '',
					hideOnSinglePage:false
				},
				lis5: [],
				boo:false,
				transData: {},
				chooseData: [],
				typeIndex: undefined
			}
		},
		props: {
			selectIndex: {
				type: Number,
				default: false,
			},
			newApply: {
				type: Number,
				default: false,
				},
			kind: {
			    type: Number,
			},
			data: {
				type: Object,
				default: true,
			},
			approvalId: {
				type: Number,
			}
		},
		watch: {
		  data(val, old) {
		    console.log(val, old)
		  },
		},
		created(){
			this.aut()
			
		},
		methods: {
			 //下拉框查询
            filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			changeNumber(data) {
				this.number = data
				console.log(this.number, 'this.number=====================')
			},
			getData(data){
				console.log(data, 'data=======================')
				this.$emit('getIdData', data)
				console.log(this.lis1,'lis1')
				if (data.apply == 0){
				this.lis1.forEach(item1 => {
					if(item1.businessKey == data.recordId) {
				this.selectedRowKeys.push(item1.id)
				Object.assign(item1, {
					goodId: data.goodId,
					goodsData: data.goodsData,
					associateId: data.associateId 

				})
				console.log(this.selectedRowKeys, 'this.selectedRowKeys-----------------------------11111==========================')
				var arr = JSON.parse(JSON.stringify(item1))
				this.rowInfo = this.rowInfo.concat(arr)
				console.log(this.rowInfo, 'rowInforowInforowInforowInforowInforowInforowInforowInfo')
					var a = this.rowInfo.length
                var newArr = []
                newArr.push(this.rowInfo[a -1])
                for(var i=this.rowInfo.length - 1; i>= 0; i--) {
                newArr.forEach(item3 => {
                if(item3.id == this.rowInfo[i].id) {
                this.rowInfo.splice(i, 1)
               } else {
               newArr.push(this.rowInfo[i])
               }
               })
                }
              this.rowInfo = newArr
				// this.selectedRowKeys = item1.id
				var obj = {}
				this.rowInfo = this.rowInfo.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				// var newLis = []
				// this.selectedRowKeys.forEach((key, idx) => {
				// 	this.rowInfo.forEach((item, index) => {
				// 		if (key == item.id) {
				
				// 			newLis.push(item)
				// 		}
				// 	})
				// })
				// this.rowInfo = newLis
				console.log(this.rowInfo,'rowInforowInforowInforowInforowInfo')

					}
				})
				} else if (data.apply == 1) {
				this.lis2.forEach(item2 => {
					if(item2.businessKey == data.recordId) {
						this.selectedRowKeys.push(item2.id)
						Object.assign(item2, {
					goodId: data.goodId,
					goodsData: data.goodsData,
					associateId : data.associateId 

				})
							console.log(this.selectedRowKeys, 'this.selectedRowKeys000000000000000000000000000000000==========================')
				var arr = JSON.parse(JSON.stringify(item2))
				this.rowInfo2 = this.rowInfo2.concat(arr)
				console.log(this.rowInfo2, 'rowInforowInforowInforowInforowInforowInforowInforowInfo')
				var a = this.rowInfo2.length
                var newArr = []
                newArr.push(this.rowInfo2[a -1])
                for(var i=this.rowInfo2.length - 1; i>= 0; i--) {
                newArr.forEach(item3 => {
                if(item3.id == this.rowInfo2[i].id) {
                this.rowInfo2.splice(i, 1)
               } else {
               newArr.push(this.rowInfo2[i])
               }
               })
                }
              this.rowInfo2 = newArr
               console.log(this.rowInfo2, 'newArrnewArrnewArrnewArrnewArrnewArrnewArr')
				// this.selectedRowKeys = l
				var obj = {}
				this.rowInfo2 = this.rowInfo2.reduce(function(item, next) {
					console.log(item, next,'nextnextnextnextnextnextnextnextnext')
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				// var newLis = []
				// this.selectedRowKeys.forEach((key, idx) => {
				// 	this.rowInfo2.forEach((item, index) => {
				// 		if (key == item.id) {
				// 						Object.assign(item, {
				// 	goodId: data.goodId,
				// 	associateId : data.associateId 

				// })
				// 			newLis.push(item)
				// 		}
				// 	})
				// })
				// this.rowInfo2 = newLis
			
				// this.selectedRowKeys = l
				// this.rowInfo2 = s
				console.log(this.rowInfo2)

					}
				})
				}else if (data.apply == 3) {
				console.log(this.selectedRowKeys, 'this.selectedRowKeys00000000000000000000000==========================')
				this.lis3.forEach(item3 => {
					console.log(item3,'item3=======================')
					if(item3.id == data.recordId) {
						this.selectedRowKeys.push(item3.id)
								Object.assign(item3, {
					goodId: data.goodId,
					goodsData: data.goodsData,
					associateId : data.associateId 

				})

						console.log(this.selectedRowKeys, 'this.selectedRowKeys111111111111111111111==========================')
							var arr = JSON.parse(JSON.stringify(item3))
				this.rowInfo3 = this.rowInfo3.concat(arr)
					var a = this.rowInfo3.length
                var newArr = []
                newArr.push(this.rowInfo3[a -1])
                for(var i=this.rowInfo3.length - 1; i>= 0; i--) {
                newArr.forEach(item3 => {
                if(item3.id == this.rowInfo3[i].id) {
                this.rowInfo3.splice(i, 1)
               } else {
               newArr.push(this.rowInfo3[i])
               }
               })
                }
              this.rowInfo3 = newArr
				// this.selectedRowKeys = l
				var obj = {}
				this.rowInfo3 = this.rowInfo3.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				// var newLis = []
				// this.selectedRowKeys.forEach((key, idx) => {
				// 	this.rowInfo3.forEach((item, index) => {
				// 					Object.assign(item, {
				// 	goodId: data.goodId,
				// 	associateId : data.associateId 

				// })
				// 		if (key == item.id) {
				// 			newLis.push(item)
				// 		}
				// 	})
				// })
				// this.rowInfo3 = newLis
				
				// this.selectedRowKeys = l
				// this.rowInfo3 = s
				console.log(this.rowInfo3)

					}
					

				})
				} else if (data.apply == 4) {
				
				this.lis4.forEach(item4 => {
					if(item4.businessKey == data.recordId) {
						this.selectedRowKeys.push(item4.id)
								Object.assign(item4, {
					goodId: data.goodId,
					goodsData: data.goodsData,
					associateId : data.associateId 

				})
						console.log(this.selectedRowKeys, 'this.selectedRowKeys22222222222222222==========================')
						var arr = JSON.parse(JSON.stringify(item4))
				this.rowInfo4 = this.rowInfo4.concat(arr)
					var a = this.rowInfo4.length
                var newArr = []
                newArr.push(this.rowInfo4[a -1])
                for(var i=this.rowInfo4.length - 1; i>= 0; i--) {
                newArr.forEach(item3 => {
                if(item3.id == this.rowInfo4[i].id) {
                this.rowInfo4.splice(i, 1)
               } else {
               newArr.push(this.rowInfo4[i])
               }
               })
                }
              this.rowInfo4 = newArr
				// this.selectedRowKeys = l
				var obj = {}
				this.rowInfo4 = this.rowInfo4.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				// var newLis = []
				// this.selectedRowKeys.forEach((key, idx) => {
				// 	this.rowInfo4.forEach((item, index) => {
				// 		if (key == item.id) {
				// 				Object.assign(item, {
				// 	goodId: data.goodId,
				// 	associateId : data.associateId 

				// })
				// 			newLis.push(item)
				// 		}
				// 	})
				// })
				// this.rowInfo4 = newLis
				

					}
				})
				}else if (data.apply == 5) {
				 console.log(this.lis5, 'lis5===============')
				this.lis5.forEach(item4 => {
					if(item4.id == data.recordId) {
						this.selectedRowKeys.push(item4.id)
								Object.assign(item4, {
								goodId: data.goodId,
								goodsData: data.goodsData,
								associateId : data.associateId 

							})
						console.log(this.selectedRowKeys, 'this.selectedRowKeys22222222222222222==========================')
						var arr = JSON.parse(JSON.stringify(item4))
			     	this.rowInfo5 = this.rowInfo5.concat(arr)
					var a = this.rowInfo5.length
                var newArr = []
                newArr.push(this.rowInfo5[a -1])
                for(var i=this.rowInfo5.length - 1; i>= 0; i--) {
                newArr.forEach(item3 => {
                if(item3.id == this.rowInfo5[i].id) {
                this.rowInfo5.splice(i, 1)
               } else {
               newArr.push(this.rowInfo5[i])
               }
               })
                }
              this.rowInfo5 = newArr
				// this.selectedRowKeys = l
				var obj = {}
				this.rowInfo5 = this.rowInfo5.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				// var newLis = []
				// this.selectedRowKeys.forEach((key, idx) => {
				// 	this.rowInfo4.forEach((item, index) => {
				// 		if (key == item.id) {
				// 				Object.assign(item, {
				// 	goodId: data.goodId,
				// 	associateId : data.associateId 

				// })
				// 			newLis.push(item)
				// 		}
				// 	})
				// })
				// this.rowInfo4 = newLis
				

					}
				})
				}
				console.log(data, 'data==========================')
				
				console.log(this.selectedRowKeys, 'this.selectedRowKeys==========================')

				

			},
			init(data) {
				// this.typeIndex = data.typeIndex
				// this.$nextTick(()=> {
				// 	this.type = data.approvalId
				// 	this.type2 = data.approvalId
				// 	this.type3 = data.approvalId
				// 	this.type4 = data.approvalId
				// 	this.getAll()
				// })
					this.typeIndex = data.typeIndex
				this.selectedRowKeys = []
				this.lis1 = []
				this.lis2 = []
				this.lis3 = []
				this.lis4 = []
				this.lis5 = []
				this.selectedRowKeys = [],
				this.rowInfo = []
				this.rowInfo2 = []
				this.rowInfo3 = []
				this.rowInfo4 = []
				this.rowInfo5 = []
				console.log(data, '9999999999999999999999999999999999999')
				data.auditCodeData.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo.push(item)
				})
				data.auditCodeData2.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo2.push(item)
				})
				data.auditCodeData3.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo3.push(item)
				})
				data.auditCodeData4.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo4.push(item)
				})
				data.auditCodeData5.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo5.push(item)
				})
				this.$nextTick(()=> {
					this.type = this.approvalId
					this.type2 = this.approvalId
					this.type3 = this.approvalId
					this.type4 = this.approvalId
					this.type5 = this.approvalId
					console.log(this.approvalId, 'approvalId==============================')
					this.getAll()
				})

			},
			show(data) {
				this.typeIndex = data.typeIndex
				this.selectedRowKeys = []
				this.lis1 = []
				this.lis2 = []
				this.lis3 = []
				this.lis4 = []
				this.lis5 = []
				this.selectedRowKeys = [],
				this.rowInfo = []
				this.rowInfo2 = []
				this.rowInfo3 = []
				this.rowInfo4 = []
				this.rowInfo5 = []
				console.log(data, '9999999999999999999999999999999999999')
				data.auditCodeData.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo.push(item)
				})
				data.auditCodeData2.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo2.push(item)
				})
				data.auditCodeData3.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo3.push(item)
				})
				data.auditCodeData4.forEach(item=>{
					this.selectedRowKeys.push(item.id)
					this.rowInfo4.push(item)
				})
				if(this.newApply == 1) {
					data.auditCodeData5.forEach(item=>{
						this.selectedRowKeys.push(item.id)
						this.rowInfo5.push(item)
					})
					this.getCompany()
			     	
				}
				
				this.$nextTick(()=> {
					this.type = this.approvalId
					this.type2 = this.approvalId
					this.type3 = this.approvalId
					this.type4 = this.approvalId
					this.type5 = this.approvalId
					console.log(this.approvalId, 'approvalId==============================')
					this.getAll()
					if(this.newApply == 1) {
					  this.get_AllData()
					}
				})
			
			},
			getCompany() {
				//获取有权限的公司部门
				limitCompany().then(res=>{
					res.forEach(item => {
					if(item.deptId){
						this.companylist.push(item)
					}
					})
				})

			},
			//有权限的部门
			handlecompany() {
				this.queryParam.deptId = undefined
				for (let i = 0; i < this.companylist.length; i++) {
				if(this.queryParam.companyId == this.companylist[i].deptId){
						this.deptList = this.companylist[i].children
						break
					}
				}
			},
			//获取所有
			getAll() {
				this.get_ing()
				this.get_done()
				this.get_mylis()
				this.get_Taskdone()
				this.aut()
				this.is_revocation = true
			},
			aut(){
				//  source: 1去掉采购申请
				audit_list({
					 source: 1
				}).then(res => {
					this.Approvallist = res.data
					console.log(this.Approvallist, 'this.Approvallist')
				})
			},
			//我的待办
			get_ing() {
				this.lis1 = []
				console.log(this.type)
				this.$nextTick(()=> {
				console.log(this.kind,'this.kind')

				if(this.kind == 1) {
				this.boo=true
				getTaskingData({
					pageNum: this.pagination1.current,
					pageSize: this.pagination1.pageSize,
					sortField: 'applyTime',
					sortOrder: 'desc',
					processDefKeys: 'purchase',
					hasPurchase: true,
					processName: this.pagination1.itemName,
					goodsName: this.goodsName
				}).then((res) => {
					const pagination1 = { ...this.pagination1
					}
					pagination1.total = res.total
					this.pagination1 = pagination1
					// var array = []
					// var data = JSON.parse(JSON.stringify(res.rows))
					// data.forEach(item => {
					// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
					// 		array.push(item)
					// 	}
					// })
					this.lis1 = res.rows
					this.boo=false
				})

				} else {
						this.boo=true
				getTaskingData({
					pageNum: this.pagination1.current,
					pageSize: this.pagination1.pageSize,
					sortField: 'applyTime',
					sortOrder: 'desc',
					hasPurchase: false,
					processDefKeys: this.type,
					processName: this.pagination1.itemName,
				}).then((res) => {
					// for(var i in res.rows) {
					// 	console.log('2222222222222222222222222222')
					// 	console.log(i,'iiiiiiiiiiiiiiiiiiiiiii')
					// 	console.log(res.rows[i].processDefKey,'res.rows[i].processDefKeys')
					// 	if(res.rows[i].processDefKey === 'purchase') {
					// 		console.log('33333')
					// 		res.rows.splice(i, 1)
					// 	}
					// } 
					const pagination1 = { ...this.pagination1
					}
					pagination1.total = res.total
					this.pagination1 = pagination1
					// var array = []
					// var data = JSON.parse(JSON.stringify(res.rows))
					// data.forEach(item => {
					// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
					// 		if(item.processDefKey != 'purchase') {
					// 			array.push(item)
					// 		}
					// 	}
					// })
					
					console.log(res.rows, 'res.rows==============')
					this.lis1 = res.rows
					this.boo=false
				})

				}
				})
			
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination1.current = pagination.current
				this.get_ing()
			},
			//我的已办
			get_done() {
				this.lis2 = []
				console.log(this.kind , 'this.kind ==========================22222222222222222222')
				if(this.kind == 1) {
					console.log(this.kind , 'this.kind ==========================22222222222222222222')
						this.boo=true
				getTaskdoneData({
					pageNum: this.pagination2.current,
					pageSize: this.pagination2.pageSize,
					sortField: 'id',
					sortOrder: 'desc',
					procDefKey: 'purchase',
					hasPurchase: true,
					title: this.pagination2.itemName,
					applyer:this.applyer2,
					goodsName: this.goodsName2
				}).then((res) => {
					console.log(res,'res----------------------------')
					const pagination2 = { ...this.pagination2
					}
					pagination2.total = res.total
					this.pagination2 = pagination2
					// var array = []
					// var data = JSON.parse(JSON.stringify(res.rows))
					// data.forEach(item => {
					// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
					// 		array.push(item)
					// 	}
					// })
					this.lis2 = res.rows
					this.boo=false
				})
				} else {
				this.boo=true
				getTaskdoneData({
					pageNum: this.pagination2.current,
					pageSize: this.pagination2.pageSize,
					sortField: 'id',
					sortOrder: 'desc',
					hasPurchase: false,
					procDefKey: this.type2,
					title: this.pagination2.itemName,
					applyer:this.applyer2
				}).then((res) => {
					console.log(res,'res----------------------------')
					const pagination2 = { ...this.pagination2
					}
					pagination2.total = res.total
					this.pagination2 = pagination2
					// var array = []
					// var data = JSON.parse(JSON.stringify(res.rows))
					// data.forEach(item => {
					// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
					// 		if(item.procDefKey != 'purchase') {
					// 			array.push(item)
					// 		}
					// 	}
					// })
					this.lis2 = res.rows
					this.boo=false
				})
				}
			},
			handleTableChange2(pagination, filters, sorter) {
				this.pagination2.current = pagination.current
				this.get_done()
			},
			//我的申请
			get_mylis() {
				this.lis3 = []
				if(this.kind == 1) {
						this.boo=true
				getBusinessListMyData({
					pageNum: this.pagination3.current,
					pageSize: this.pagination3.pageSize,
					procDefKey: 'purchase',
					sortField: 'id',
					sortOrder: 'desc',
					hasPurchase: true,
					searchValue: this.pagination3.itemName,
					applyer:this.applyer3,
					goodsName: this.goodsName3
				}).then((res) => {
					const pagination3 = { ...this.pagination3
					}
					pagination3.total = res.total
					this.pagination3 = pagination3
					// var array = []
					// var data = JSON.parse(JSON.stringify(res.rows))
					// data.forEach(item => {
					// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
					// 		array.push(item)
					// 	}
					// })
					this.lis3 = res.rows
					this.boo=false
				})
				} else {
					this.boo=true
				getBusinessListMyData({
					pageNum: this.pagination3.current,
					pageSize: this.pagination3.pageSize,
					procDefKey: this.type3,
					sortField: 'id',
					sortOrder: 'desc',
					hasPurchase: false,
					searchValue: this.pagination3.itemName,
					applyer:this.applyer3
				}).then((res) => {
					const pagination3 = { ...this.pagination3
					}
					pagination3.total = res.total
					this.pagination3 = pagination3
					// var array = []
					// var data = JSON.parse(JSON.stringify(res.rows))
					// data.forEach(item => {
					// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
					// 		if(item.procDefKey != 'purchase') {
					// 			array.push(item)
					// 		}
					// 	}
					// })
				
					this.lis3 = res.rows
					this.boo=false
				})

				}
				
			},
			//抄送我的
			get_Taskdone() {
				this.lis4 = []
				if(this.kind == 1) {
					this.boo=true
				getTaskdone_ccData({
					pageNum: this.pagination4.current,
					pageSize: this.pagination4.pageSize,
					procDefKey: 'purchase',
					sortField: 'id',
					sortOrder: 'desc',
					hasPurchase: true,
					searchValue: this.pagination4.itemName,
					applyer:this.applyer4,
					goodsName: this.goodsName4
				}).then((res) => {
					const pagination4 = { ...this.pagination4
					}
					pagination4.total = res.total
					this.pagination4 = pagination4
					this.lis4 = res.rows
					this.boo=false
				})

				} else {
				this.boo=true
				getTaskdone_ccData({
					pageNum: this.pagination4.current,
					pageSize: this.pagination4.pageSize,
					procDefKey: this.type4,
					sortField: 'id',
					sortOrder: 'desc',
					hasPurchase: false,
					searchValue: this.pagination4.itemName,
					applyer:this.applyer4
				}).then((res) => {
					const pagination4 = { ...this.pagination4
					}
					pagination4.total = res.total
					this.pagination4 = pagination4
					// var array = []
					// var data = JSON.parse(JSON.stringify(res.rows))
					// data.forEach(item => {
					// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
					// 		if(item.procDefKey != 'purchase') {
					// 			array.push(item)
					// 		}
					// 	}
					// })
					this.lis4 = res.rows
					this.boo=false
				})
			    }
			},
			//全部
			get_AllData() {
				this.lis5 = []
				console.log(this.kind , 'this.kind ==========================')
				if(this.kind == 1) {
					this.boo=true
					getall({
						companyId: this.queryParam.companyId,
						deptId: this.queryParam.deptId,
						applyer: this.queryParam.applyer5,
						applyCode: this.queryParam.applyCode,
						type: 'purchase',
						hasPurchase: true,
						pageNum: this.pagination5.current,
						pageSize: this.pagination5.pageSize,
					}).then(res => {
						const pagination5 = { ...this.pagination5}
						pagination5.total = res.total
						this.pagination5 = pagination5
						// var array = []
						// var data = JSON.parse(JSON.stringify(res.rows))
						// data.forEach(item => {
						// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
						// 		array.push(item)
						// 	}
						// })
						
						// res.rows.forEach(item)
						this.lis5 = res.rows
						this.boo =false
					})
				} else {
					this.boo=true
					getall({
						companyId: this.queryParam.companyId,
						deptId: this.queryParam.deptId,
						applyer: this.queryParam.applyer5,
						applyCode: this.queryParam.applyCode,
						hasPurchase: false,
						type: this.type5,
						pageNum: this.pagination5.current,
						pageSize: this.pagination5.pageSize,
					}).then(res => {
						const pagination5 = { ...this.pagination5}
						pagination5.total = res.total
						this.pagination5 = pagination5
						var array = []
						// var data = JSON.parse(JSON.stringify(res.rows))
						// data.forEach(item => {
						// 	if(item.result != 3 && item.result != 4 && item.result != 6) {
						// 		array.push(item)
						// 	}
						// })
						this.lis5 = res.rows
						this.boo =false
					})
				}
				// getTaskdone_cc({
				// 	pageNum: this.pagination4.current,
				// 	pageSize: this.pagination4.pageSize,
				// 	procDefKey: 'purchase',
				// 	sortField: 'id',
				// 	sortOrder: 'desc',
				// 	searchValue: this.pagination4.itemName,
				// 	applyer:this.applyer4,
				// 	goodsName: this.goodsName4
				// }).then((res) => {
				// 	const pagination4 = { ...this.pagination3
				// 	}
				// 	pagination4.total = res.total
				// 	this.pagination4 = pagination4
				// 	this.lis4 = res.rows
				// 	this.boo=false
				// })

				// } else {
				// this.boo=true
				// getTaskdone_cc({
				// 	pageNum: this.pagination4.current,
				// 	pageSize: this.pagination4.pageSize,
				// 	procDefKey: this.type4,
				// 	sortField: 'id',
				// 	sortOrder: 'desc',
				// 	searchValue: this.pagination4.itemName,
				// 	applyer:this.applyer4
				// }).then((res) => {
				// 	const pagination4 = { ...this.pagination3
				// 	}
				// 	pagination4.total = res.total
				// 	this.pagination4 = pagination4
				// 	this.lis4 = res.rows
				// 	this.boo=false
				// })
			},
			// 全部
			// 全部
			handleTableChange5(pagination, filters, sorter) {
				this.pagination5.current = pagination.current
				this.pagination5.pageSize =  pagination.pageSize
				this.get_AllData()
			},
			handleTableChange3(pagination, filters, sorter) {
				this.pagination3.current = pagination.current
				this.get_mylis()
			},
			handleTableChange4(pagination, filters, sorter) {
				this.pagination4.current = pagination.current
				this.get_Taskdone()
			},
			show_details(row) {

			},
			callback(res) {
				this.activeKey = res
			},
			//显示详情
			showDail(row) {
				this.number = 0
				var fdStart =  row.procDefKey.indexOf("payment-")
				if(fdStart == 0) {
					this.$refs.newPaymentModel.init(row)
				} else {
					var modal = modalMap[row.procDefKey]
					console.log(modal, 'modal================')
					this.$refs[modal].show({
						businessKey: row.id,
					})
				}
			},
			showGoods3(row) {
					this.number = 1
					this.apply = 3
					var modal = modalMap[row.procDefKey]
				this.$refs[modal].show({
					businessKey: row.id,
				})

			},
			//显示详情
			showDail2(row) {
				this.number = 0
				 var fdStart =  row.procDefKey.indexOf("payment-")
				if(fdStart == 0) {
					this.$refs.newPaymentModel.init(row)
				} else {
					var modal = modalMap[row.procDefKey]
					this.$refs[modal].show({
						businessKey: row.businessKey,
					})
				}
			},
			//全部的详情
			showDail5(row) {
				console.log(row, 'row==========================')
				this.number = 0
				 var fdStart =  row.procDefKey.indexOf("payment-")
				if(fdStart == 0) {
					this.$refs.newPaymentModel.init(row)
				} else {
					var modal = modalMap[row.procDefKey]
					console.log(modal, 'modal==========================')
					this.$refs[modal].show({
						businessKey: row.id,
					})
				}
			},
			showDaildb(row) {
				this.number = 0
				 var fdStart =  row.processDefKey.indexOf("payment-")
				if(fdStart == 0) {
					this.$refs.newPaymentModel.init(row)
				} else {
				var modal = modalMap[row.processDefKey]
				console.log(modalMap[row.processDefKey], 'model=================')
				this.$refs[modal].show({
					businessKey: row.businessKey,
				})
				}
			},
			showGoods(row) {
				console.log(row, 'row==========================')
				this.number = 1
				this.apply = 0
				this.$refs.purchasemodal.show({
					businessKey: row.businessKey,
					rowInfo: this.rowInfo 
				// this.rowInfo2 = []
				// this.rowInfo3 = []
				// this.rowInfo4 = []
				})

			},
			showGoods1(row) {
				console.log(row, 'row==========================')
				this.number = 1
				this.apply = 1
				this.$refs.purchasemodal.show({
					businessKey: row.businessKey,
				})

			},
			showGoods2(row) {
				console.log(row, 'row==========================')
				this.number = 1
				this.apply = 2
				this.$refs.purchasemodal.show({
					businessKey: row.businessKey,
				})

			},
			showGoods5(row) {
					console.log(row, 'row==========================')
				this.number = 1
				this.apply = 5
				this.$refs.purchasemodal.show({
					businessKey: row.id,
				})
			},
			onSelectChange(l, s) {
				console.log(s,'ssssssssssssssssssssssss')
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo = this.rowInfo.concat(arr)
				// this.selectedRowKeys = l
				  if (this.kind == 1) {
					console.log(this.chooseData, 'this.chooseData')
					if(l.length < this.selectedRowKeys.length) {
						console.log(l, 'lllllllllllllllllllllll')
						var arr = this.selectedRowKeys
						console.log(arr, 'arrarrarrarrarrarrarr')

                    for(var i=0; i<l.length; i++){
						console.log(i,'iiiiiiiiiiiiiiiiiiii')
		              for(var k=0; k<arr.length; k++){
						console.log(k,'kkkkkkkkkkkkkkkkkkk')
		                if(l[i]  == arr[k]){
							console.log('aaaaaaaaaaaaaaaaaa')
		                   arr.splice(k,1)
	                	}
	                 }
                     }
					 this.lis1.forEach( item=> {
						if(item.id == arr ) {
							item.goodId = ''
							item.goodsData = []
							item.associateId = ''
							this.selectedRowKeys = l
						}

					 })
					 

					} else {
						 if(s[s.length-1].goodId) {
						console.log('00000000000000000000000000')
				this.selectedRowKeys = l
			  } else {
				console.log('11111111111111111111111')
				// this.$message.error('请选择关联物品！')
				this.$confirm({
					title: '请选择关联物品！',
				
				})
				return
				
			  }

					}
			
			 } else {
					console.log('222222222222222222222222222')
				this.selectedRowKeys = l

			 }
				var obj = {}
				this.rowInfo = this.rowInfo.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo = newLis
				// this.selectedRowKeys = l
				// this.rowInfo = s
				console.log(this.rowInfo)
				console.log( this.selectedRowKeys,' this.selectedRowKeys')
			},
			onSelectChange2(l, s) {
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo2 = this.rowInfo2.concat(arr)
				// this.selectedRowKeys = l
				 if (this.kind == 1) {
					console.log(this.chooseData, 'this.chooseData')
					if(l.length < this.selectedRowKeys.length) {
						console.log(l, 'lllllllllllllllllllllll')
						var arr = this.selectedRowKeys
						console.log(arr, 'arrarrarrarrarrarrarr')

                    for(var i=0; i<l.length; i++){
						console.log(i,'iiiiiiiiiiiiiiiiiiii')
		              for(var k=0; k<arr.length; k++){
						console.log(k,'kkkkkkkkkkkkkkkkkkk')
		                if(l[i]  == arr[k]){
							console.log('aaaaaaaaaaaaaaaaaa')
		                   arr.splice(k,1)
	                	}
	                 }
                     }
					 this.lis2.forEach( item=> {
						if(item.id == arr ) {
							item.goodId = ''
							item.goodsData = []
							item.associateId = ''
							this.selectedRowKeys = l
						}

					 })
					 

					} else {
						 if(s[s.length-1].goodId) {
						console.log('00000000000000000000000000')
				this.selectedRowKeys = l
			  } else {
				console.log('11111111111111111111111')
				// this.$message.error('请选择关联物品！')
				this.$confirm({
					title: '请选择关联物品！',
				
				})
				return
				
			  }

					}
			
			 } else {
					console.log('222222222222222222222222222')
				this.selectedRowKeys = l

			 }
			 console.log(this.selectedRowKeys, 'this.selectedRowKeys=============')
				var obj = {}
				this.rowInfo2 = this.rowInfo2.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo2.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo2 = newLis
				// this.selectedRowKeys = l
				// this.rowInfo2 = s
				console.log(this.rowInfo2)
			},
			onSelectChange3(l, s) {
				console.log(l, 'lllllllllllllllllllllllllllllllllll')
				console.log(this.chooseData, 'this.chooseData================')
				console.log(this.selectedRowKeys, 'this.selectedRowKeys=====================')
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo3 = this.rowInfo3.concat(arr)
				// this.selectedRowKeys = l
			 if (this.kind == 1) {
					console.log(this.chooseData, 'this.chooseData')
					if(l.length < this.selectedRowKeys.length) {
						console.log(l, 'lllllllllllllllllllllll')
						var arr = this.selectedRowKeys
						console.log(arr, 'arrarrarrarrarrarrarr')

                    for(var i=0; i<l.length; i++){
						console.log(i,'iiiiiiiiiiiiiiiiiiii')
		              for(var k=0; k<arr.length; k++){
						console.log(k,'kkkkkkkkkkkkkkkkkkk')
		                if(l[i]  == arr[k]){
							console.log('aaaaaaaaaaaaaaaaaa')
		                   arr.splice(k,1)
	                	}
	                 }
                     }
					 this.lis3.forEach( item=> {
						if(item.id == arr ) {
							item.goodId = ''
							item.goodsData = []
							item.associateId = ''
							this.selectedRowKeys = l
						}

					 })
					 

					} else {
						 if(s[s.length-1].goodId) {
						console.log('00000000000000000000000000')
				this.selectedRowKeys = l
			  } else {
				console.log('11111111111111111111111')
				// this.$message.error('请选择关联物品！')
				this.$confirm({
					title: '请选择关联物品！',
				
				})
				return
				
			  }

					}
			
			 } else {
					console.log('222222222222222222222222222')
				this.selectedRowKeys = l

			 }
				var obj = {}
				this.rowInfo3 = this.rowInfo3.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo3.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo3 = newLis
				// this.selectedRowKeys = l
				// this.rowInfo3 = s
				console.log(this.rowInfo3)
			},
			onSelectChange4(l, s) {
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo4 = this.rowInfo4.concat(arr)
           if (this.kind == 1) {
					console.log(this.chooseData, 'this.chooseData')
					if(l.length < this.selectedRowKeys.length) {
						console.log(l, 'lllllllllllllllllllllll')
						var arr = this.selectedRowKeys
						console.log(arr, 'arrarrarrarrarrarrarr')

                    for(var i=0; i<l.length; i++){
						console.log(i,'iiiiiiiiiiiiiiiiiiii')
		              for(var k=0; k<arr.length; k++){
						console.log(k,'kkkkkkkkkkkkkkkkkkk')
		                if(l[i]  == arr[k]){
							console.log('aaaaaaaaaaaaaaaaaa')
		                   arr.splice(k,1)
	                	}
	                 }
                     }
					 this.lis4.forEach( item=> {
						if(item.id == arr ) {
							item.goodId = ''
							item.goodsData = []
							item.associateId = ''
							this.selectedRowKeys = l
						}

					 })
					 

					} else {
						 if(s[s.length-1].goodId) {
						console.log('00000000000000000000000000')
				this.selectedRowKeys = l
			  } else {
				console.log('11111111111111111111111')
				// this.$message.error('请选择关联物品！')
				this.$confirm({
					title: '请选择关联物品！',
				
				})
				return
				
			  }

					}
			
			 } else {
					console.log('222222222222222222222222222')
				this.selectedRowKeys = l

			 }
				var obj = {}
				this.rowInfo4 = this.rowInfo4.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo4.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo4 = newLis
			},
			onSelectChange5(l, s) {
				// this.selectedRowKeys = l
				// this.rowInfo5 = s
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo5 = this.rowInfo5.concat(arr)
				console.log(this.rowInfo5, this.kind,'this.rowInfo5====================')
				if (this.kind == 1) {
					if(l.length < this.selectedRowKeys.length) {
						console.log(l, 'lllllllllllllllllllllll')
						var arr = this.selectedRowKeys
						console.log(arr, 'arrarrarrarrarrarrarr')
						for(var i=0; i<l.length; i++){
							console.log(i,'iiiiiiiiiiiiiiiiiiii')
						for(var k=0; k<arr.length; k++){
							console.log(k,'kkkkkkkkkkkkkkkkkkk')
							if(l[i]  == arr[k]){
								console.log('aaaaaaaaaaaaaaaaaa')
							arr.splice(k,1)
							}
						}
						}
						this.lis5.forEach( item=> {
							if(item.id == arr ) {
								item.goodId = ''
								item.goodsData = []
								item.associateId = ''
								this.selectedRowKeys = l
							}

						})
					} else {
							if(s[s.length-1].goodId) {
							console.log('00000000000000000000000000')
							this.selectedRowKeys = l
							} else {
								console.log('11111111111111111111111')
								// this.$message.error('请选择关联物品！')
								this.$confirm({
									title: '请选择关联物品！',
								})
								return
							}
					    }
					
					} else {
						console.log('222222222222222222222222222')
						this.selectedRowKeys = l
					}
					var obj = {}
					this.rowInfo5 = this.rowInfo5.reduce(function(item, next) {
						obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
						return item
					}, [])
					var newLis = []
					this.selectedRowKeys.forEach((key, idx) => {
						this.rowInfo5.forEach((item, index) => {
							if (key == item.id) {
								newLis.push(item)
							}
						})
					})
					this.rowInfo5 = newLis
					console.log(this.rowInfo5, 'this.rowInfo5===========================')
			},
			//关闭弹窗
			closeDetali() {
				this.is_revocation = false
				var dataType = 1
				this.$emit('getDataList',dataType)

			},
			//选择单号
			selectCode() {
				console.log('9999999999999999999999999999999')
					this.selectedRowKeys = []
				console.log(this.selectedRowKeys, 'this.selectedRowKeys')
				this.$emit('applyData', this.rowInfo)
				this.$emit('applyData2', this.rowInfo2)
				this.$emit('applyData3', this.rowInfo3)
				this.$emit('applyData4', this.rowInfo4)
				this.$emit('applyData5', this.rowInfo5)
				// this.rowInfo = []
				// this.rowInfo2 = []
				// this.rowInfo3 = []
				// this.rowInfo4 = []
				this.is_revocation = false
			},
		},
	}
</script>